export default "__VITE_ASSET__BTOsXBk9__"